import React from "react";
import styles from "./CategoryUpdate.module.css";
import Toggle from "../../utils/Toggle/Toggle";

function SubcategoryCreateForm({
  showSubcategoryForm,
  setShowSubcategoryForm,
  newSubcategory,
  setNewSubcategory,
  subcategoryImageInputRef,
  handleSubcategoryImageClick,
  handleSubcategoryImageChange,
  handleCreateSubcategory,
}) {
  return (
    <>
      <button
        type="button"
        className={styles.subCategoryButton}
        onClick={() => setShowSubcategoryForm(!showSubcategoryForm)}
      >
        {showSubcategoryForm ? "Cancel" : "Create Subcategory"}
      </button>

      {showSubcategoryForm ? (
        <div className={styles.subcategoryForm}>
          <h2 className={styles.subcategoryHeading}>Subcategory Details</h2>
          <div className={styles.first}>
            <p>Enter the Subcategory Sort Id</p>
            <input
              name="subcategorySortId"
              placeholder="Subcategory Sort ID"
              type="number"
              onChange={(event) =>
                setNewSubcategory((prev) => ({
                  ...prev,
                  sortId: event.target.value,
                }))
              }
              id={styles.gap}
              value={newSubcategory.sortId}
            ></input>
          </div>
          <div className={styles.second}>
            <p>Enter the Subcategory Name</p>
            <input
              name="subcategoryName"
              placeholder="Subcategory Name"
              type="text"
              onChange={(event) =>
                setNewSubcategory((prev) => ({
                  ...prev,
                  name: event.target.value,
                }))
              }
              id={styles.gap}
              value={newSubcategory.name}
            ></input>
          </div>
          <div className={styles.imageurl}>
            <p>Upload Subcategory Image</p>
            <div
              className={styles.imageUploadDiv}
              onClick={handleSubcategoryImageClick}
            >
              {newSubcategory.image ? (
                <img
                  src={newSubcategory.image}
                  alt="Subcategory Image"
                  className={styles.uploadedImage}
                />
              ) : (
                <div className={styles.uploadPlaceholder}>
                  <span>Click to upload image</span>
                </div>
              )}
            </div>
            <input
              ref={subcategoryImageInputRef}
              type="file"
              accept="image/*"
              style={{ display: "none" }}
              onChange={handleSubcategoryImageChange}
            />
          </div>
          <div className={styles.availability}>
            <p style={{ marginBottom: "16px" }}>Is Subcategory Active?</p>
            <Toggle
              status={newSubcategory.isActive}
              setStatus={(value) =>
                setNewSubcategory((prev) => ({
                  ...prev,
                  isActive: value,
                }))
              }
            />
          </div>
          <button
            type="button"
            className={styles.subCategoryButton}
            onClick={handleCreateSubcategory}
          >
            Create Subcategory
          </button>
        </div>
      ) : null}
    </>
  );
}

export default SubcategoryCreateForm;
